import React from 'react';
import './NotFound.scss';

const NotFound = () => {
    return (
        <div className='container mt-5'>
            <div className='card p-4 shadow'>
                <div className="m-auto not-found">
                    <h5>404 - Page Not Found</h5>
                    <p>Sorry, the page you are looking for does not exist.</p>
                    <a href="/">Go back to Home</a>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
